import {
	GetMeshTrafficKeyHistoryRequest,
	GetMeshTrafficKeyHistoryResponse,
	SkipScheduledTrafficKeyRotationRequest,
	SkipScheduledTrafficKeyRotationResponse,
	TriggerTrafficKeyRotationRequest,
	TriggerTrafficKeyRotationResponse,
	UpdateScheduledTrafficKeyRotationRequest,
	UpdateScheduledTrafficKeyRotationResponse,
} from "@somewear/api";
import { createActionSet } from "@somewear/model";

export const workspaceMeshKeyRotationsActions = {
	getMeshTrafficKeyHistory: createActionSet<
		GetMeshTrafficKeyHistoryRequest.AsObject,
		GetMeshTrafficKeyHistoryResponse.AsObject
	>("workspace/getMeshTrafficKeyHistory"),
	triggerMeshKeyRotation: createActionSet<
		TriggerTrafficKeyRotationRequest.AsObject,
		TriggerTrafficKeyRotationResponse.AsObject
	>("workspace/triggerMeshKeyRotation"),
	scheduleMeshTrafficKeyRotation: createActionSet<
		UpdateScheduledTrafficKeyRotationRequest.AsObject,
		UpdateScheduledTrafficKeyRotationResponse.AsObject
	>("workspace/scheduleMeshTrafficKeyRotation"),
	skipScheduledMeshTrafficKeyRotation: createActionSet<
		SkipScheduledTrafficKeyRotationRequest.AsObject,
		SkipScheduledTrafficKeyRotationResponse.AsObject
	>("workspace/skipScheduledMeshTrafficKeyRotation"),
};
